var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 19.487 17.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "marketing-svgrepo-com",
    d: "M14.25,2.1A1.25,1.25,0,0,0,13.08,2L6.91,4.43a1.22,1.22,0,0,1-.46.09H2.5A1.25,1.25,0,0,0,1.25,5.77v.1H0v3H1.25V9A1.25,1.25,0,0,0,2.5,10.22L4,13.4a1.26,1.26,0,0,0,1.13.72h.63A1.25,1.25,0,0,0,7,12.87V10.34l6.08,2.43a1.27,1.27,0,0,0,.47.09,1.29,1.29,0,0,0,.7-.22,1.25,1.25,0,0,0,.55-1V3.13a1.25,1.25,0,0,0-.55-1.03ZM5.75,5.77V9H2.5V5.77Zm0,7.1H5.12L3.89,10.22H5.75ZM7.37,9.15A2.29,2.29,0,0,0,7,9V5.7a2.26,2.26,0,0,0,.37-.11l6.18-2.46v8.48Zm7.46-3.03v2.5a1.25,1.25,0,1,0,0-2.5Z",
    transform: "translate(-0.712 4.262) rotate(-22)",
    fill: "#97a2b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.8b60d428e9026abfe362bdfc49b17370.svg";
export { ForwardRef as ReactComponent };